import pinWarningSvg from 'src/assets/pin-warning.raw.svg';
import SvgMarker from './SvgMarker';

export default class WarningSvgMarker extends SvgMarker {
  constructor() {
    super(pinWarningSvg, {
      height: 81,
      width: 60,
      innerColor: '#000',
      outerColor: '#F2C037',
    });
  }
}
